export default __webpack_public_path__ + "static/media/30inex_02.12af0bf7.png";